import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const before = ['Passi ore a cercare materiali sparsi online', 'Non sai se il livello è adatto alla tua classe', "Improvvisi le lezioni all'ultimo minuto", 'Ti senti insicuro/a nella teoria musicale', 'Nessuna verifica pronta da usare'];
const after = ['Ogni lezione è già pronta, dalla pagina 1', 'Percorso a spirale calibrato per età, dalla primaria alle medie', '60 unità già strutturate: introduzione, attività, scheda, verifica', 'Guida passo-passo pensata anche per chi non è musicista', 'Verifiche e griglie di valutazione incluse in ogni volume'];
export function BeforeAfter() {
  return <section className="w-full bg-cream-deep px-5 py-16 sm:py-24" data-id="element-18" data-mp="39qv78i4vb9tb">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="39r4ye91nfn0l">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange sm:text-xs" data-id="element-20" data-mp="2vrcccr12huyy">
          Il costo di partire da zero
        </p>
        <h2 className="mt-4 text-center text-[26px] font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-21" data-mp="30s9q8rf1o2un">
          Ogni Settimana da Rifare, o Ogni Lezione Già Pronta.
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-22" data-mp="t2f9bzdpqxj4">
          <div className="rounded-4xl border border-navy/10 bg-white p-7 sm:p-9" data-id="element-23" data-mp="1739m0u7snknl">
            <h3 className="text-xs font-extrabold uppercase tracking-[0.18em] text-orange" data-id="element-24" data-mp="123wonfjaqv6r">
              Prima
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-25" data-mp="ef41a7gqpvnr">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-26" data-mp="9fhlprdfw3bs">
                  <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-orange-tint" data-id="element-27" data-mp="9d4xiwh38wqa">
                    <XIcon className="h-3.5 w-3.5 text-orange-deep" aria-hidden="true" data-id="element-28" data-mp="jcned41pc2e4" />
                  </span>
                  <span className="text-[15px] leading-relaxed text-ink-soft" data-id="element-29" data-mp="3rs725njlssls">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-4xl border border-navy/20 bg-navy p-7 sm:p-9" data-id="element-30" data-mp="3ms1iatjksae9">
            <h3 className="text-xs font-extrabold uppercase tracking-[0.18em] text-orange" data-id="element-31" data-mp="1qqhe0iggaas2">
              Con Musica Pronta
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-32" data-mp="20gsoyoyjxk8g">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-33" data-mp="24i4k1a072xo1">
                  <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-white/15" data-id="element-34" data-mp="24hcofz6lkzxr">
                    <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-35" data-mp="17u83240ui0ca" />
                  </span>
                  <span className="text-[15px] leading-relaxed text-white/90" data-id="element-36" data-mp="1gsjq5w2i6fzz">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-base font-medium leading-relaxed text-navy sm:text-lg" data-id="element-37" data-mp="1lpjvg4rj3eq1">
          Un sistema musicale completo: prepari meno e insegni con più sicurezza.
        </p>
      </div>
    </section>;
}